import Layout, { LayoutProps } from '@dev.boon/wolfe/src/layouts/default-layout';
import { MENU_LINKS } from '@wanders.root/config/menu';
import { WOLFE_URL } from '@wanders.root/config/endpoints';
import { FOOTER_LINKS } from '@wanders.root/config/footer';

const DefaultLayout = (ComposedComponent, overrides: LayoutProps = {}) => {
    return Layout(ComposedComponent, {
        hideCustomerChat: true,
        ...overrides,
        headerOptions: {
            menuLinks: MENU_LINKS,
            logoLink: WOLFE_URL,
            isLogoAbsolute: true,
        },
        footerOptions: {
            menuLinks: FOOTER_LINKS,
        },
    });
};

export default DefaultLayout;
